import { TableHead as UITableHead, TableTitle } from '@genial/components';
import React from 'react';

import { fixOrderFields, widthCols, tableHead } from '../../../constants';
import { TableHeadProps } from '../../../models';

import { TableHeadLoading } from './loading';

export const TableHead: React.FC<TableHeadProps> = (props) => {
  const tableHeadData = Object.entries(tableHead);

  const TableCustomerTitle = tableHeadData.map((item, index) => {
    const width = Object.entries(widthCols).map((col) => col[1])[index];
    const [field, title] = item as string[];
    const testId = `table-customer-title-${index}`;

    const fieldName = fixOrderFields(field);

    const columnSort = { sort: 'name', sortDirection: 'asc' };
    const columnSortByFilter = columnSort;
    const columnSortBySearchTerm = columnSort;

    const { sort, sortDirection } = props.isSearch ? columnSortBySearchTerm : columnSortByFilter;

    const orderByIsASC = sortDirection === 'desc';
    const orderByIsSelected = fieldName === sort;

    return (
      <TableTitle
        testId={testId}
        key={fieldName}
        width={width}
        hasOrder={false}
        orderByIsASC={orderByIsASC}
        orderByIsSelected={orderByIsSelected}>
        {title}
      </TableTitle>
    );
  });

  if (props.isLoading) {
    return <TableHeadLoading />;
  }

  return <UITableHead testId="table-customer-head">{TableCustomerTitle}</UITableHead>;
};
